import { Button, Stack } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import EmptyState from "./EmptyState";

/**
 * Inline error block. Same anatomy as EmptyState, with a warning icon and
 * an optional retry action.
 */
export default function ErrorState({
  title = "Something went wrong",
  description,
  onRetry,
  retryLabel = "Try again",
  sx,
}) {
  return (
    <EmptyState
      icon={<ErrorOutlineIcon sx={{ fontSize: 36, color: "error.main" }} />}
      title={title}
      description={description}
      action={
        onRetry ? (
          <Stack direction="row" spacing={1}>
            <Button variant="outlined" size="small" onClick={onRetry}>
              {retryLabel}
            </Button>
          </Stack>
        ) : null
      }
      sx={sx}
    />
  );
}
